const baseUrl = API_V4_URL;
const DATATYPE_JSON = 'application/json';

const headers = (
    requireToken = true,
    contentType = DATATYPE_JSON
) => ({
    'Content-Type': contentType,
    ...(requireToken ? {'Authorization': localStorage.getItem('v4token')} : undefined)
});

const combinePath = path => baseUrl + path;

const sendGetRequest = (path, params, requireToken = true) => {
    const url = combinePath(addQueryParametersToPath(path, params));
    return $.ajax({
        url,
        method: 'GET',
        headers: headers(requireToken)
    });
};

const sendPostRequest = (path, data, requireToken = true, dataType = 'application/json') => {
    const url = combinePath(path);
    data = JSON.stringify(data);
    console.log(baseUrl)
    return $.ajax({
        url,
        method: 'POST',
        headers: headers(requireToken, dataType),
        data,
        statusCode: {
            401: function() {
                // Redirect the to the login page.
                if(window.location.pathname !== "/login.php") {
                    location.href = "./login.php";
                }
            },
        }
    });
};

const sendPostUploadFileRequest = (path, formData) => {
    const url = combinePath(path);

    return $.ajax({
        url: url,
        method: 'POST',
        headers: {
            'Authorization': localStorage.getItem('v4token')
        },
        data: formData,
        contentType: false,
        processData: false,
        statusCode: {
            401: function() {
                // Redirect the to the login page.
                if(window.location.pathname !== "/login.php") {
                    location.href = "./login.php";
                }
            },
        }
    });
};

const sendPatchRequest = (path, data, requireToken = true) => {
    const url = combinePath(path);
    data = JSON.stringify(data);
    return $.ajax({
        url,
        method: 'PATCH',
        headers: headers(requireToken),
        data
    });
};

const sendPutRequest = (path, data, requireToken = true) => {
    const url = combinePath(path);
    data = JSON.stringify(data);
    return $.ajax({
        url,
        method: 'PUT',
        headers: headers(requireToken),
        data
    });
};

const sendDeleteRequest = (path, requireToken = true) => {
    const url = combinePath(path);
    return $.ajax({
        url,
        method: 'DELETE',
        headers: headers(requireToken),
    });
};

const sendDeleteRequestWithData = (path, data, requireToken = true) => {
    const url = combinePath(path);
    data = JSON.stringify(data);
    return $.ajax({
        url,
        method: 'DELETE',
        headers: headers(requireToken),
        data
    });
};

const addQueryParametersToPath = (path, params = {}) => {
    let queryParameters = path.includes('?') ? '&' : '?';
    for (const key of (Object.keys(params))) {
        queryParameters += `${key}=${params[key]}&`;
    }
    queryParameters = queryParameters.substr(0, queryParameters.length - 1);
    return path + queryParameters;
};

export {
    sendGetRequest,
    sendPostRequest,
    sendPostUploadFileRequest,
    sendPutRequest,
    sendPatchRequest,
    sendDeleteRequest,
    sendDeleteRequestWithData,
};
